<div class="flex-row align-items-center justify-content-center" style="margin: 0 auto; padding: 48px; width: 100%">
  <i class="ri-loader-4-line spin"></i>
  {{ 'info.loading_data' | translate }}
</div>

